
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import MarkdownDemo from './demo/compare-markdown.twig';
import HTMLDemo from './demo/compare-html.twig';
import GutenbergDemo from './demo/compare-gutenberg.twig';
import CommentDemo from './demo/compare-comment.twig';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Vendor/WordPress/Core Element Comparison" mdxType="Meta" />
    <h1>{`Comparing Core Element Rendering`}</h1>
    <p>{`Some native HTML elements, like `}<inlineCode parentName="p">{`blockquote`}</inlineCode>{` and `}<inlineCode parentName="p">{`table`}</inlineCode>{` can be added by multiple means, including legacy blog posts containing Classic blocks with markup, HTML blocks, Markdown blocks, and core WordPress blocks.`}</p>
    <p>{`This page compares how they render so we can ensure things work the same way across the board.`}</p>
    <h2>{`Markdown Block`}</h2>
    <Canvas mdxType="Canvas">
  <Story name="Markdown" mdxType="Story">{() => MarkdownDemo()}</Story>
    </Canvas>
    <h2>{`HTML Block`}</h2>
    <p>{`This is a block containing raw HTML markup. It also represents legacy blog posts containing Classic blocks. Even when those blog posts were originally written in Markdown, the Classic block converts them to raw HTML.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="HTML" mdxType="Story">{() => HTMLDemo()}</Story>
    </Canvas>
    <h2>{`Gutenberg blocks`}</h2>
    <p>{`This shows the same set of elements created using core WordPress blocks.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Gutenberg" mdxType="Story">{() => GutenbergDemo()}</Story>
    </Canvas>
    <h2>{`Comments`}</h2>
    <p>{`This shows the same set of elements created in a comment.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Comments" mdxType="Story">{() => CommentDemo()}</Story>
    </Canvas>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const markdown = (() => MarkdownDemo());
markdown.storyName = 'Markdown';
markdown.parameters = { storySource: { source: '() => MarkdownDemo()' } };

export const html = (() => HTMLDemo());
html.storyName = 'HTML';
html.parameters = { storySource: { source: '() => HTMLDemo()' } };

export const gutenberg = (() => GutenbergDemo());
gutenberg.storyName = 'Gutenberg';
gutenberg.parameters = { storySource: { source: '() => GutenbergDemo()' } };

export const comments = (() => CommentDemo());
comments.storyName = 'Comments';
comments.parameters = { storySource: { source: '() => CommentDemo()' } };

const componentMeta = { title: 'Vendor/WordPress/Core Element Comparison', includeStories: ["markdown","html","gutenberg","comments"],  };

const mdxStoryNameToKey = {"Markdown":"markdown","HTML":"html","Gutenberg":"gutenberg","Comments":"comments"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;